var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 26.3333C12.4666 26.3333 13.6666 25.1333 13.6666 23.6667H8.33328C8.33328 24.3739 8.61423 25.0522 9.11433 25.5523C9.61443 26.0524 10.2927 26.3333 10.9999 26.3333ZM18.9999 18.3333V11.6667C18.9999 7.57333 16.8133 4.14667 12.9999 3.24V2.33333C12.9999 1.22667 12.1066 0.333334 10.9999 0.333334C9.89328 0.333334 8.99995 1.22667 8.99995 2.33333V3.24C5.17328 4.14667 2.99995 7.56 2.99995 11.6667V18.3333L1.27995 20.0533C0.439947 20.8933 1.02661 22.3333 2.21328 22.3333H19.7733C20.9599 22.3333 21.5599 20.8933 20.7199 20.0533L18.9999 18.3333Z",
    fill: "#C6C7C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.feebbf3537af77f27a9a67a094838521.svg";
export { ForwardRef as ReactComponent };